$(function() {
  // ボタンにマウスオーバーしたら
  $(document).on(
    {
      'touchstart': function() {
        return $(this).off('mouseenter mouseleave');
      },

      'touchstart mouseenter':function(){
        const $title = $(this).find('.js-dropMenuBtn')
        const $content = $(this).find('.js-dropMenuContents')
        // 初期化
        $('.l-gnaviPc-list_item').removeClass('is-active')
        $('.js-dropMenuBtn').removeClass('is-open')
        $('.js-dropMenuContents').removeClass('is-open')
        // open
        $(this).addClass('is-active')
        $title.addClass('is-open')
        $content.addClass('is-open')
      },
      'mouseleave':function(){
        const $title = $(this).find('.js-dropMenuBtn')
        const $content = $(this).find('.js-dropMenuContents')
        // close
        $(this).removeClass('is-active')
        $title.removeClass('is-open')
        $content.removeClass('is-open')
      }
    },
    '.l-gnaviPc-list_item'
  )

  // タブレット等大画面のタッチデバイス用処理
  $(document).on('click touchend', function(e) {
    if (!$(e.target).closest('.js-dropMenuContents,.js-dropMenuBtn').length) {
      $('.l-gnaviPc-list_item').removeClass('is-active')
      $('.js-dropMenuBtn').removeClass('is-open')
      $('.js-dropMenuContents').removeClass('is-open')
    }
  });

})
